import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Chip } from "@mui/material";
import { t } from "i18next";
import api from "../../../../helpers/api/Api";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import RouteUrls from "../../../../helpers/urls/RouteUrls";
import UserTypes from "../../../../helpers/constants/UserTypes";
import Table from "../../../../components/Tables/Table";
import DisabledSwitch from "../../../../components/DisabledSwitch";
import DeleteButton from "../../../../components/DeleteButton";
import EditPermissions from "./components/editPermissions";
import EditUser from "./components/edit";
import EditUserDomains from "./components/editDomains";
import UserTableSearch from "./components/search";
import UserSelectMore from "./components/userSelectMore";
import EditUserIPs from "./components/editIPs";
import PagePermBits from "../../../../helpers/constants/PagePermBits";

function UserManagement() {
  const use_dispatch = useDispatch();
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [listReload, setListReload] = useState(0);
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: t("user.user_id"), accessor: "user", align: "left" },
    { Header: t("user.name"), accessor: "name", align: "center" },
    { Header: t("user.type"), accessor: "type", align: "center" },
    ...(userInfo.type == 0 || (userInfo.type == 1 && userInfo.parent == 0)) ? [{ Header: t("user.permissions_edit"), accessor: "permission", align: "center" }] : [],
    ...(userInfo.type == 0 || userInfo.type == 1) ? [{ Header: t("user.domain_edit"), accessor: "domain", align: "center" }] : [],
    ...(userInfo.type == 0) ? [{ Header: t("user.ip_edit"), accessor: "anycastip", align: "center" }] : [],
    { Header: t("global.status"), accessor: "disabled", align: "center" },
    { Header: t("global.edit"), accessor: "edit", align: "center", width: '10%' },
    { Header: t("global.delete"), accessor: "delete", align: "center", width: '10%' },
    { Header: t("global.actions"), accessor: "actions", align: "center", width: '10%' },
  ];
  const [formData, setFormData] = useState({
    search: ""
  });

  const setDataList = (data) => {
    let anycastIPs;
    if (userInfo.type == 0) {
      const anycastIPsString = data.filter((u) => u.id == 1)[0].anycastips;
      anycastIPs = anycastIPsString.split(",");
    }

    const temp_rows = data.map((user) => {
      return {
        user: (<div className="font-weight-bold">{user.user}</div>),
        name: user.name,
        type: returnType(user.type),
        permission: (
          <EditPermissions
            user={user}
            disabled={user.id == 1 || (userInfo.type != 0 && user.id == userInfo.id)}
            handleCloseModal={handleCloseModal}
          />
        ),
        domain: (((userInfo.type == 0) && (user.type == 2 || (user.type == 1 && user.parentid == 0))) ||
                  ((userInfo.type == 0 || userInfo.type == 1) && (user.type == 2)) ?
            <EditUserDomains
              user={user}
              handleCloseModal={handleCloseModal}
            />
            : null
        ),
        anycastip: ((userInfo.type == 0 && user.type == 1) ?
              <EditUserIPs
                 user={user}
                 anycastIPs={anycastIPs}
                 handleCloseModal={handleCloseModal}
              />
              : null
        ),
        disabled: (
          <DisabledSwitch
            item={user}
            itemName={t("user.user")}
            disableUrl={ApiUrls.user.edit}
            disabled={user.id == 1}
          />
        ),
        edit: (
          <EditUser
            user={user}
            disabled={user.id == 1}
            handleCloseModal={handleCloseModal}
          />
        ),
        delete: (
          <DeleteButton
            item={user}
            disabled={user.id == 1 || user.id == userInfo.id}
            itemName={t("user.user")}
            deleteUrl={ApiUrls.user.delete}
            handleCloseModal={handleCloseModal}
          />
        ),
        actions: (
           <UserSelectMore
              user={user}
           />
        )
      }
    });

    setRows(temp_rows);
  }

  useEffect(() => {
    getDomainsList();
  }, []);

  const getDomainsList = () => {
    api.post(ApiUrls.domain.list, {})
      .then((response) => {
        use_dispatch({
          type: "SET_DOMAIN_LIST",
          payload: response.data.data
        });
      })
      .catch((error) => {});
  }

  const returnType = (type) => {
    const rowType = UserTypes[type];
    return <Chip label={rowType.name} color={rowType.chipColor} size="small" />
  }

  const handleCloseModal = () => {
    setListReload(listReload+1);
  }

  return (
    <Table
      columns={columns}
      rows={rows}
      setDataList={setDataList}
      listReload={listReload}
      addUrl={RouteUrls.user.add}
      getListUrl={ApiUrls.user.list}
      itemName={t("user.user")}
      itemPName={t("user.users")}
      search={
        <UserTableSearch
          formData={formData}
          setFormData={setFormData}
        />
      }
      formData={formData}
      setFormData={setFormData}
      listPermBit={PagePermBits.userManagement}
    />
  );
}

export default UserManagement;
